/**
 * Created by Kevin Dench on 6/15/2016.
 *
 * API Service for Unique Parts
 * @callback successCallback
 * @callback errorCallback
 */
/* @ngInject */
export default function UniquePartApiService($resource, $http, $q, __env) {
    let comparableParts;
    return {
        setComparablePart: function (parts) {
            comparableParts = parts;
        },
        getComparablePart: function () {
            return comparableParts;
        },
        getUniquePart: function (uniquePn, callBack) {
            $resource(
                `${__env.intellidataApiUrl}unique-parts/:pn/`
            ).get(
                {pn: uniquePn},
                callBack
            );
        },
        /**
         * This method will resolve all the promises in parallel, then pass the results to a callback.
         * {@see https://docs.angularjs.org/api/ng/service/$q#all}
         * {@see https://stackoverflow.com/questions/23136652/angularjs-how-to-combine-identical-parallel-http-resource-requests-in-a-fac}
         *
         * @param {string[]}        uniquePns       - Array of Unique Part strings.
         * @param {successCallback} successCallback - The callback that handles a successful response.
         * @param {errorCallback}   errorCallback   - The callback that handles an error response.
         */
        getUniqueParts: function (uniquePns, successCallback, errorCallback) {
            var promises = [];
            if (uniquePns !== undefined && Array.isArray(uniquePns)) {
                for (var i = 0; i < uniquePns.length; ++i) {
                    var encodedPart = encodeURIComponent(uniquePns[i]);
                    promises.push(
                        $http({
                            method: 'GET',
                            url: `${__env.intellidataApiUrl}unique-parts/${encodedPart}`
                        })
                    );
                }
            }
            $q.all(promises).then(successCallback)['catch'](errorCallback);
        },
        getParameterValues: function (uniquePn, callBack) {
            $resource(
                `${__env.intellidataApiUrl}unique-parts/:pn/values`,
                {pn: uniquePn}
            ).query(callBack);
        },
        getParameterValuesByDisplayArea: function (uniquePn, dA, callBack) {
            $resource(
                `${__env.intellidataApiUrl}unique-parts/:pn/values`,
                {pn: uniquePn, displayArea: dA}
            ).query(callBack);
        },
        getDescription: function (uniquePn, callBack) {
            $resource(
                `${__env.intellidataApiUrl}unique-parts/:uniquePn/descriptions`
            ).get(
                {uniquePn: uniquePn},
                callBack
            );
        },
        getUniquePartsByParameterValueIds: function (parameterValueIds, callBack) {
            $resource(
                `${__env.intellidataApiUrl}parametervalues/:pvIds/unique-parts`
            ).get(
                {pvIds: parameterValueIds},
                callBack
            );
        },
        getUniquePartsByDefinitionAndDisplayArea: function (definitionId, dA, callBack) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:definitionId/unique-parts`,
                {definitionId: definitionId, displayArea: dA}
            ).query(callBack);
        }
    };
}
